import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDocument: null,
  isDocumentResponse: false,
  tcDocumentList: null,
  estimateODTTemplate: null,
  quoteODTTemplate: null,
  confirmationODTTemplate: null,
  contractODTTemplate: [],
  invoiceODTTemplate: null,
  isFeedbackQuestionResponse: false,
  genenralInfoData: null,
  isGeneralInfoResponse: false,
};

const documentSlice = createSlice({
  name: "document",
  initialState,

  reducers: {
    getAllTCDocumentListAction: (state) => {},
    setAllTCDocumentListAction: (state, { payload }) => {
      state.tcDocumentList = payload;
    },
    setEstimateODTTemplateAction: (state, { payload }) => {
      state.estimateODTTemplate = payload;
    },
    setQuoteODTTemplateAction: (state, { payload }) => {
      state.quoteODTTemplate = payload;
    },
    setConfirmationODTTemplateAction: (state, { payload }) => {
      state.confirmationODTTemplate = payload;
    },
    setInvoiceODTTemplateAction: (state, { payload }) => {
      state.invoiceODTTemplate = payload;
    },

    setContractODTTemplateAction:(state,{payload})=>{
      state.contractODTTemplate = payload;
    },

    getTCDocumentAction: (state,{payload}) => {},
    setTCDocumentAction: (state, { payload }) => {
      state.selectedDocument = payload;
    },

    updateTCDocumentAction: (state, { payload }) => {},
    setUpdateTCDocumentAction: (state, { payload }) => {
      state.isDocumentResponse = payload;
    },

    getUploadFileKeyAction: (state, { payload }) => {},
    setUploadFileKeyAction: (state, { payload }) => {
      // state.imageUploadKey = payload
    },

    addFeedbackQuestionAction: (state, { payload }) => {},
    setAddFeedbackQuestionAction: (state, { payload }) => {
      state.isFeedbackQuestionResponse = payload;
    },

    getGeneralInformationAction: (state) => {},
    setGeneralInformationAction: (state, { payload }) => {
      state.genenralInfoData = payload;
    },

    addGeneralInformationAction: (state, { payload }) => {},
    updateGeneralInformationAction: (state, { payload }) => {},
    setAddGeneralInformationAction: (state, { payload }) => {
      state.isGeneralInfoResponse = payload;
    },
  },
});

const {
  getAllTCDocumentListAction,
  setAllTCDocumentListAction,
  setEstimateODTTemplateAction,
  setQuoteODTTemplateAction,
  setConfirmationODTTemplateAction,
  setInvoiceODTTemplateAction,
  getTCDocumentAction,
  setContractODTTemplateAction,
  setTCDocumentAction,
  updateTCDocumentAction,
  setUpdateTCDocumentAction,
  getUploadFileKeyAction,
  setUploadFileKeyAction,
  addFeedbackQuestionAction,
  setAddFeedbackQuestionAction,
  getGeneralInformationAction,
  setGeneralInformationAction,
  addGeneralInformationAction,
  setAddGeneralInformationAction,
  updateGeneralInformationAction,
} = documentSlice.actions;

export {
  getAllTCDocumentListAction,
  setAllTCDocumentListAction,
  setEstimateODTTemplateAction,
  setQuoteODTTemplateAction,
  setConfirmationODTTemplateAction,
  setInvoiceODTTemplateAction,
  setContractODTTemplateAction,
  getTCDocumentAction,
  setTCDocumentAction,
  updateTCDocumentAction,
  setUpdateTCDocumentAction,
  getUploadFileKeyAction,
  setUploadFileKeyAction,
  addFeedbackQuestionAction,
  setAddFeedbackQuestionAction,
  getGeneralInformationAction,
  setGeneralInformationAction,
  addGeneralInformationAction,
  setAddGeneralInformationAction,
  updateGeneralInformationAction,
};

export default documentSlice.reducer;
